<template>
    <div class="login-wrap">
        <div class="ms-login">
            <div class="ms-title">工程机械管理后台</div>
            <el-form :model="param" :rules="rules" ref="login" label-width="0px" class="ms-content">
                <el-form-item prop="loginName">
                    <el-input v-model="param.loginName" placeholder="账号">
                        <el-button slot="prepend" icon="el-icon-lx-people"></el-button>
                    </el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input
                        type="password"
                        placeholder="密码"
                        v-model="param.password"
                        @keyup.enter.native="submitForm()"
                    >
                        <el-button slot="prepend" icon="el-icon-lx-lock"></el-button>
                    </el-input>
                </el-form-item>
								<div class="verifyCode">
										<el-input v-model="inputCode" placeholder="请输入验证码" />
									 <verify-code ref="verifyCodeRef" />
								</div>
                <div class="login-btn">
                    <el-button type="primary" @click="submitForm()">登录</el-button>
                </div>
                <!-- <p class="login-tips">Tips : 用户名和密码随便填。</p> -->
            </el-form>
        </div>
    </div>
</template>

<script>
import { login, listTaskRemindNum } from '../api/index';
import VerifyCode from "@/components/VerifyCode.vue";
export default {
	 components: {
	    VerifyCode,
	  },
    data: function() {
        return {
            param: {
                loginName: '',
                password: ''
            },
            rules: {
                loginName: [{ required: true, message: '请输入账号', trigger: 'blur' }],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
            },
						inputCode: ''
        };
    },
    methods: {
        submitForm() {
            this.$refs.login.validate(valid => {
                if (valid) {
										if(!this.inputCode) {
											this.$message.error('请输入验证码')
											return
										}
										const isCorrect = this.$refs.verifyCodeRef.validateCode(this.inputCode);
										if(!isCorrect) {
											this.$message.error('验证码错误，请重新输入')
											this.$refs.verifyCodeRef.refreshCode();
											this.inputCode = "";
											return
										}
									
                    login(this.param).then(res => {
                        // 获取数据成功后的其他操作
                        if (res.code == 0) {
                            console.log(res);
                            this.$message.success('登录成功');
                            localStorage.setItem('ms_username', res.data.personName);
                            localStorage.setItem('organizationKind', res.data.organizationKind);
                            localStorage.setItem('role', res.data.role);

                            var token = res.data.tokenType + ' ' + res.data.token;

                            localStorage.setItem('Authorization', token);
                            sessionStorage.setItem('Authorization', token)
                            localStorage.setItem('responsibleArea', res.data.responsibleArea);
                            listTaskRemindNum({}).then(ress => {
                                this.$store.state.totalNum = ress.data.totalNum;
                            });

                            //this.$router.push('/');
                            if (res.data.organizationKind == 2) {
                                if (res.data.role == 1) {
                                    this.$router.push('/branchmgment');
                                } else if (res.data.role == 2) {
                                    this.$router.push('/licenseapplys');
                                } else if (res.data.role == 3) {
                                    this.$router.push('/licenseapplys');
                                }
                            } else {
																if(res.data.role == 20) {
																	this.$router.push('/fzorganlicenseapplys/third/1');
																}else {
																	// 分支
																	this.$router.push('/fzorganadmin');
																}
                            }
                        } else {
													this.$refs.verifyCodeRef.refreshCode();
													this.inputCode = "";
                            this.$message({
                                message: res.message,
                                type: 'error'
                            });
                        }
                    });
                } else {
                    this.$message.error('请输入账号和密码');
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    }
};
</script>

<style scoped>
.login-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    background-image: url(../assets/img/login-bg.jpg);
    background-size: 100%;
}
.ms-title {
    width: 100%;
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    color: #333;
    border-bottom: 1px solid #ddd;
}
.ms-login {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 350px;
    margin: -190px 0 0 -175px;
    border-radius: 5px;
    background: rgba(255, 255, 255, 0.6);
    overflow: hidden;
}
.ms-content {
    padding: 30px 30px;
}
.login-btn {
    text-align: center;
}
.login-btn button {
    width: 100%;
    height: 36px;
    margin-bottom: 10px;
}
.login-tips {
    font-size: 12px;
    line-height: 30px;
    color: #fff;
}
.verifyCode {
	display: flex;
	align-items: center;
	margin-bottom: 15px;
	justify-content: space-between;
}
.verifyCode .el-input {
	width: 150px;
}
</style>